import { render, staticRenderFns } from "./BetgameEditIcon.vue?vue&type=template&id=66915e60&scoped=true"
import script from "./BetgameEditIcon.vue?vue&type=script&lang=js"
export * from "./BetgameEditIcon.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditIcon.vue?vue&type=style&index=0&id=66915e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66915e60",
  null
  
)

export default component.exports